import styled from 'styled-components';
import { FormButton } from '@belong/ui-components';

export const ButtonLinkWrapper = styled(FormButton)`
  align-self: center;
`;
